export const getters = {
  /**
   * @param {UIState} state
   * @returns {string|null}
   */
  getStickyBannerHeight(state) {
    return state.stickyBannerHeight ? state.stickyBannerHeight : null;
  },
};
